import request from '@/axios'
import VueCookie from 'vue-cookie'
import vm from '../../main'
import {
	Message
} from 'element-ui';
import {
	Loading
} from 'element-ui';
// 获取省份
let token = sessionStorage.getItem("token")
export async function getProvince() {
	if (sessionStorage.getItem('getProvince')) {
		let data = JSON.parse(sessionStorage.getItem('getProvince'));
		return data;
	}
	let res = await request({
		api: 'plan',
		url: "Filter/ProvinceFilter",
		method: 'get',
		data: {
			educationLevel: "",
		}
	})
	sessionStorage.setItem('getProvince', JSON.stringify(res.data));
	return res.data;
}
//获取业务省份
export async function getBusinessProvince() {
	if (sessionStorage.getItem("getBusinessProvince")) {
		let data = JSON.parse(sessionStorage.getItem("getBusinessProvince"));
		return data;
	}
	let res = await request({
		api: 'plan',
		url: "Filter/BusinessProvinceFilter",
		method: 'get',
	})
	sessionStorage.setItem("getBusinessProvince", JSON.stringify(res.data));
	return res.data;
}
// 获取院校特色
export async function getTrait() {
	if (sessionStorage.getItem("getTrait")) {
		let data = JSON.parse(sessionStorage.getItem("getTrait"));
		return data;
	}
	let res = await request({
		api: 'plan',
		url: "Filter/SchoolTraitFilter",
		method: 'get',
	})
	sessionStorage.setItem("getTrait", JSON.stringify(res.data));
	return res.data;
}
// 获取院校性质
export async function getNature() {
	if (sessionStorage.getItem("getNature")) {
		let data = JSON.parse(sessionStorage.getItem("getNature"));
		return data;
	}
	let res = await request({
		api: 'plan',
		url: "Filter/SchoolNatureFilter",
		method: 'get',
	})
	sessionStorage.setItem("getNature", JSON.stringify(res.data));
	return res.data;
}

// 获取学历层次
export async function getEducationLevel() {
	if (sessionStorage.getItem("getEducationLevel")) {
		let data = JSON.parse(sessionStorage.getItem("getEducationLevel"));
		return data;
	}
	let res = await request({
		api: 'plan',
		url: "Filter/EducationLevelFilter",
		method: 'get',
	})
	sessionStorage.setItem("getEducationLevel", JSON.stringify(res.data));
	return res.data;
}

//专业层次
export async function getMajorLevel() {
	if (sessionStorage.getItem("getMajorLevel")) {
		let data = JSON.parse(sessionStorage.getItem("getMajorLevel"));
		return data;
	}
	let res = await request({
		api: 'plan',
		url: "Filter/MajorLevelFilter",
		method: 'get',
	})
	sessionStorage.setItem("getMajorLevel", JSON.stringify(res.data));
	return res.data;
}
//专业类型
export async function getMajorType() {
	if (sessionStorage.getItem("getMajorType")) {
		let data = JSON.parse(sessionStorage.getItem("getMajorType"));
		return data;
	}
	let res = await request({
		api: 'plan',
		url: "Filter/MajorTypeFilter",
		method: 'get',
	})
	sessionStorage.setItem("getMajorType", JSON.stringify(res.data));
	return res.data;
}
//职业类型
export async function getJobType() {
	if (sessionStorage.getItem("getJobType")) {
		let data = JSON.parse(sessionStorage.getItem("getJobType"));
		return data;
	}
	let res = await request({
		api: 'plan',
		url: "Filter/JobTypeFilter",
		method: 'get',
	})
	sessionStorage.setItem("getJobType", JSON.stringify(res.data));
	return res.data;
}
//年份
export async function getYear() {
	if (sessionStorage.getItem("getYear")) {
		let data = JSON.parse(sessionStorage.getItem("getYear"));
		return data;
	}
	// if (!token) return;
	let res = await request({
		api: 'plan',
		url: "Filter/YearFilter",
		method: 'get',
	})
	sessionStorage.setItem("getYear", JSON.stringify(res.data));
	return res.data;
}
//院校
export async function getSchool(paramater) {
	// if (!token) return;
	let res = await request({
		api: 'plan',
		url: "Filter/SchoolFilter",
		method: 'get',
		data: paramater
	})
	return res.data;
}
//批次
export async function getEnrollBatchFilter(paramater) {
	// if (!token) return;
	let res = await request({
		api: 'plan',
		url: "Filter/EnrollBatchFilterNew",
		method: 'get',
		data: paramater
	})
	return res.data;
}
//文理
export async function getArtsSciencesFilter(paramater) {
	// if (!token) return;
	let res = await request({
		api: 'plan',
		url: "Filter/ArtsSciencesFilter",
		method: 'get',
		data: paramater
	})
	return res.data;
}
//专业名称
export async function getMajorNameFilter(paramater) {
	// if (!token) return;
	let res = await request({
		api: 'plan',
		url: "Filter/MajorNameFilterNew",
		method: 'get',
		data: paramater
	})
	return res.data;
}
// 将数组对象中的时间把t截取
export function splitStr(list, attr) {
	for (let i in list) {
		if (list[i][attr]) {
			list[i][attr] = list[i][attr].split("T")[0];
		}
	}
	return list;
}


// 将数组对象中的某个属性字符串转为数组
export function strToArr(list, attr) {
	for (let i in list) {
		if (list[i][attr]) {
			list[i][attr] = list[i][attr].split(",");
		}
	}
	return list;
}

//字典配置code
export async function getDictionaryCode(code) {
	if (sessionStorage.getItem(code)) {
		let data = JSON.parse(sessionStorage.getItem(code));
		return data;
	}
	let res = await request({
		api: 'plan',
		url: "Dictionary/Code?",
		method: 'get',
		data: {
			code
		}
	})
	if (res.data.length == 0) return
	sessionStorage.setItem(code, JSON.stringify(res.data[0].dictList))
	return res.data[0].dictList;
}

// 和sort方法配合此方法 根据数组对象中的某个参数进行正序排序
export function compare(property) {
	return function(a, b) {
		var value1 = a[property];
		var value2 = b[property];
		if (!value1 && value1 != 0) {
			//定义null特殊值的差值
			return 999
		}
		if (!value2 && value1 != 0) {
			return -999
		}
		return value1 - value2
	};
}
export function compare3(property) {
	return function(a, b) {
		var value1 = a[property];
		var value2 = b[property];
		return value1 - value2
	};
}
//进行倒序排序
export function compare2(property) {
	return function(a, b) {
		var value1 = a[property];
		var value2 = b[property];
		return value2 - value1;
	};
}
export async function logoOut() {
	let loginInfo = VueCookie.get('loginInfo') ? JSON.parse(VueCookie.get('loginInfo')) : {}
	await request({
		api: 'plan',
		url: "Login/LogOut",
		headers: {
			RefreshToken: loginInfo.refresh_token
		}
	}).then(res => {
		vm.cookie.delete("token");
		vm.cookie.delete("userInfo");
		vm.cookie.delete("loginInfo");
		vm.cookie.delete("checked");
		sessionStorage.removeItem("getBusinessProvince")
		vm.$goBackNuxt('/');
	})
}
//获取全部缓存数据
export const getDataCache = async () => {
	if (vm.cookie.get("token")) {
		await request({
			api: 'plan',
			url: "DataCache",
		}).then(res => {
			let {
				data
			} = res
			localStorage.clear()
			let userInfo = JSON.parse(vm.cookie.get("userInfo"))
			for (let item of data) {
				let arr = item.key.split('~')
				if (arr[0] == userInfo.province) {
					localStorage.setItem(item.key, item.value)
				}
			}
		})
	}


}
let loadingInstance = null;

// 显示Loading
function showLoading() {
	loadingInstance = Loading.service({
		lock: true,
		text: '加载中...',
		background: 'rgba(0, 0, 0, 0)'
	});
}

// 隐藏Loading
function hideLoading() {
	if (loadingInstance) {
		loadingInstance.close();
	}
}
//存储缓存数据
export const setDataCache = async (key, value, norequest) => {
	showLoading(); // 在请求前显示Loading
	if (vm.cookie.get("token")) {
		let userInfo = JSON.parse(vm.cookie.get("userInfo"))
		let province_key = `${userInfo.province}~${key}`
		localStorage.setItem(province_key, value)
		if (norequest){
			hideLoading(); // 请求完成后关闭Loading
			return;
		}
		await request({
			api: 'plan',
			url: "DataCache",
			method: 'post',
			data: {
				key: province_key,
				value
			}
		}).then(res => {
			let loadingTime = setTimeout(() => {
				hideLoading(); // 请求完成后关闭Loading
				clearTimeout(loadingTime)
			}, 500)
		}).catch(err => {
			let loadingTime = setTimeout(() => {
				hideLoading(); // 请求完成后关闭Loading
				clearTimeout(loadingTime)
			}, 500)
		})
	}

}
//删除缓存数据
export const deleteDataCache = (id) => {
	request({
		api: 'plan',
		url: `DataCache/${id}`,
		method: 'delete',
	})
}
//获取定位
export const getMyIp = async () => {
	return await request({
		api: 'plan',
		url: `Filter/ByIp`,
	})
}

export const formatNumber = (num, decimals = 3) => {
	if (isNaN(num) || num === null || num === undefined) {
		return '';
	}

	const isInteger = Math.abs(num - Math.floor(num)) < Number.EPSILON;
	if (isInteger) {
		return num.toString();
	} else {
		return num.toFixed(decimals).replace(new RegExp(`\\.?0{${decimals - 1},}$`), '');
	}
}
